import type { $Fetch } from "nitropack";

export interface NamedRef {
    id: string;
    name: string;
}

export interface BigScoreContext {
    rank: number;
    score: number;
    skill: NamedRef;
    industry?: NamedRef;
    market_segment?: NamedRef;
    persona?: NamedRef;
    deal_size?: NamedRef;
    company_size?: NamedRef;
}

export interface BigScoreResponse {
    score: number | null;
    is_visible: boolean;
    top_contexts: BigScoreContext[];
    top_skills: string[];
    suggestions?: string[];
}

export const BigScoreRepository = (client: $Fetch) => ({
    get: (slug: string, config?: any): Promise<BigScoreResponse> => {
        return client(`/v2/users/${slug}/big-score`, { ...config });
    },
    updateVisibility: (slug: string, is_visible: boolean): Promise<{ is_visible: boolean }> => {
        return client(`/v2/users/${slug}/big-score/visibility`, {
            method: 'PATCH',
            body: JSON.stringify({ is_visible }),
            headers: { 'Content-Type': 'application/json' },
        });
    },
});
